import { Order, OrderPaymentStatus, PickupStatus } from '@leid/api-orders'

import { OrderItemInfo } from 'appTypes/orders'
import { getDifferenceInHours, utcNow } from 'utils/dates'

import { OrderItemPickupStatus } from '../components/models'

import { getOrderItemFromDate, getOrderItemToDate } from './orderDates'

export const getOrderItemPickupStatus = (orderItemInfo: OrderItemInfo, order: Order): OrderItemPickupStatus => {
  const { orderItem } = orderItemInfo

  if (orderItem.status === OrderPaymentStatus.canceled || orderItem.status === OrderPaymentStatus.paidAndCanceled) {
    return OrderItemPickupStatus.CANCELED
  }

  if (orderItem.status === OrderPaymentStatus.paymentStarted && orderItemInfo.prolongations.some((s) => !s.confirmed)) {
    return OrderItemPickupStatus.NONE
  }

  if (orderItem.status !== OrderPaymentStatus.paid && orderItem.pickupStatus === PickupStatus.EMPTY) {
    return OrderItemPickupStatus.NOT_PAID
  }

  const now = utcNow()

  if (orderItem.pickupStatus === PickupStatus.EMPTY && order.paidDate && orderItem.rentedFrom) {
    const difference = getDifferenceInHours(order.paidDate, orderItem.rentedFrom)
    if (difference > 0 && difference <= 1) {
      // If order was paid less than an hour before order item start - make it available for pickup
      return OrderItemPickupStatus.STARTED
    }
  }

  const fromDate = getOrderItemFromDate(orderItem)
  if (orderItem.pickupStatus === PickupStatus.EMPTY && fromDate && fromDate.getTime() >= now.getTime()) {
    // Order is paid but it's not yet started (15 minutes before real order start)
    return OrderItemPickupStatus.NOT_STARTED
  }

  if (orderItem.productData && orderItem.productData.complementary) {
    // If it's complementary
    if (orderItem.pickupStatus === PickupStatus.COMPLETED) {
      return OrderItemPickupStatus.CONSUMABLE_PICKEDUP
    }

    return OrderItemPickupStatus.CONSUMABLE
  }

  if (orderItem.pickupStatus === PickupStatus.COMPLETED) {
    return OrderItemPickupStatus.COMPLETED
  }

  if (orderItem.pickupStatus === PickupStatus.RETURNED) {
    return OrderItemPickupStatus.RETURNED
  }

  const toDate = getOrderItemToDate(orderItem)
  if (toDate && toDate.getTime() <= now.getTime()) {
    // Order is paid but it's after order end date (15 minutes after real order end)
    return OrderItemPickupStatus.ENDED
  }

  if (orderItem.pickupStatus === PickupStatus.PICKEDUP) {
    return OrderItemPickupStatus.PICKED_UP
  }

  return OrderItemPickupStatus.STARTED
}
